/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import { createStore } from '@evertrue/et-flux';
import InteractionSearchSource from 'apps/interactions/sources/interaction-search-source';
import FilterStore from 'apps/filters/stores/filter-store';
import CoreSearchSource from 'apps/core-search/sources/core-search-source';
import SortUtils from 'mixins/sort-utils';
import QueryContext from 'entities/search/query-parts/query-context';
import ParentDoc from 'entities/search/query-parts/parent-doc-query';
import Query from 'entities/search/query-parts/query';
import PaginationUtils from 'mixins/pagination-utils';

const LIMIT = 25;

export default createStore('InteractionSearchStore', {
  getInitialState() {
    return {
      interactions: {},
      loading: false,
      page: 1,
      limit: LIMIT,
      sort: {
        prop: 'date_occurred',
        reverse: true,
      },
    };
  },

  registerActions() {
    this.on(InteractionSearchSource.actions.query, this.respondToQuery);
    this.on(InteractionSearchSource.actions.loading, this.respondToLoading);
    this.on(InteractionSearchSource.actions.fetchedInteractions, this.respondToFetched);
    this.on(InteractionSearchSource.actions.sort, this.respondToSort);
    this.on(InteractionSearchSource.actions.paginate, this.respondToPaginate);
    this.on(InteractionSearchSource.actions.setPage, this.respondToSetPage);
    this.on(InteractionSearchSource.actions.setPageSize, this.respondToSetPageSize);

    this.on(CoreSearchSource.actions.query, function (type) {
      if (type === 'interactions') {
        return this.respondToQuery();
      }
    });
  },

  respondToQuery() {
    this.setState({ page: 1, query_type: 'filter' });
    return this.queryInteractions();
  },

  respondToLoading(is_loading) {
    return this.setState({ loading: is_loading });
  },

  respondToFetched(interactions) {
    const query_type = this.getState('query_type');
    if (query_type === 'page') {
      // For pagination, replace the results entirely
      return this.setState({ interactions });
    } else {
      // For filters/sort, merge results (legacy behavior)
      const cached = this.getState('interactions');
      return this.setState({
        interactions: PaginationUtils.mergePagedResults(cached, interactions),
      });
    }
  },

  respondToSort(prop, reverse) {
    this.setState({
      query_type: 'sort',
      sort: { prop, reverse },
      page: 1,
    });
    return this.queryInteractions();
  },

  respondToPaginate() {
    this.setState({
      page: this.getState('page') + 1,
      query_type: 'page',
    });
    return this.queryInteractions();
  },

  respondToSetPage(page) {
    this.setState({
      page,
      query_type: 'page',
    });
    return this.queryInteractions();
  },

  respondToSetPageSize(pageSize) {
    this.setState({
      page: 1,
      limit: pageSize,
      query_type: 'page',
    });
    return this.queryInteractions();
  },

  queryInteractions() {
    if (!FilterStore.getLoading()) {
      let query;
      const sort = this.getState('sort');
      const filters = FilterStore.getActiveFilters();
      const operator = FilterStore.getOperator();

      if (filters && Object.keys(filters).length > 0) {
        // This currently works because you cannot have a has_child and "or" search
        if (operator === 'or') {
          query = {
            has_parent: [
              {
                type: 'contact',
                query: FilterStore.getActiveFiltersQuery(),
              },
            ],
          };
        } else {
          query = QueryContext(
            'contact_note',
            Query([ParentDoc('contact', FilterStore.getActiveFiltersQueryObject())])
          );
          query = query.toJSON();
        }
      } else {
        query = {};
      }

      query.sort = SortUtils.getQuery(sort.prop, sort.reverse);

      const page_data = {
        page: this.getState('page'),
        limit: this.getState('limit'),
      };

      return InteractionSearchSource.fetch({
        query,
        params: PaginationUtils.getParams(page_data),
      });
    }
  },

  api: {
    getInteractions() {
      return this.getState('interactions');
    },

    getLoading() {
      return this.getState('loading') && this.getState('page') === 1;
    },

    getLoadingPage() {
      return this.getState('loading') && this.getState('page') !== 1;
    },

    getSort() {
      return this.getState('sort');
    },

    hasMoreToLoad() {
      const interactions = this.getState('interactions');
      return interactions && interactions.total > interactions.offset + interactions.limit;
    },

    getPage() {
      return this.getState('page');
    },

    getLimit() {
      return this.getState('limit');
    },
  },
});
